export default __webpack_public_path__ + "static/media/emotional_deck.5fd6699e.svg";